module.exports = __webpack_public_path__ + "img/unique-interactions.958a24b9.png";